export default "__VITE_ASSET__CNdpBrCp__"